export default __webpack_public_path__ + "fonts/Format_1452.ttf";